import { useEffect, useRef, useState } from 'react';
import {
  Collapse,
  IconButton,
  Stack,
  TextField,
  type TextFieldProps,
  Typography,
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
export default function FormFieldWrapper({
  title,
  description,
  descriptionVerbose,
  fieldComponent,
  row = false,
  accordionView,
  ...textFieldProps
}: {
  title: string;
  description?: string;
  descriptionVerbose?: string | React.ReactNode;
  fieldComponent?: React.ReactNode;
  row?: boolean;
  accordionView?: boolean;
} & TextFieldProps) {
  const textFieldRef = useRef<HTMLDivElement | null>(null);
  const textInputRef = useRef<HTMLTextAreaElement | HTMLInputElement | null>(null);
  const [isContentOpen, setIsContentOpen] = useState(false);

  const isMultiline = textFieldProps.multiline;

  useEffect(() => {
    if (isMultiline && textInputRef.current) {
      if (textInputRef.current.style.height) {
        textInputRef.current.style.minHeight = textInputRef.current.style.height;
      }
    }
  }, [textFieldRef, isMultiline]); //minheight apply to textArea

  return (
    <Stack
      sx={{
        background: (theme) => theme.palette.neutral[100],
        borderRadius: 2,
        border: (theme) => `1px solid ${theme.palette.neutral[200]}`,
      }}
      p={2}
      direction={row ? 'row' : undefined}
      justifyContent={row ? 'space-between' : undefined}
      alignItems={row ? 'center' : undefined}
      gap={2}
    >
      <Stack>
        <Stack gap={2} direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
          <Typography fontWeight={700}>{title}</Typography>

          {accordionView && (
            <IconButton
              onClick={() => setIsContentOpen((prev) => !prev)}
              sx={{
                transform: isContentOpen ? 'scaleY(-1)' : 'none',
                transition: 'transform .3s ease',
              }}
            >
              <KeyboardArrowDownIcon />
            </IconButton>
          )}
        </Stack>

        {!!description && (
          <Typography variant="body2" color="grey" whiteSpace={'pre-line'}>
            {description}
          </Typography>
        )}

        {!!descriptionVerbose && accordionView && (
          <Collapse in={accordionView ? isContentOpen : true}>
            {typeof descriptionVerbose === 'string' && (
              <Typography variant="body2" color="grey" whiteSpace={'pre-line'} pt={2}>
                {descriptionVerbose}
              </Typography>
            )}

            {typeof descriptionVerbose !== 'string' && descriptionVerbose}
          </Collapse>
        )}
      </Stack>

      <Collapse in={accordionView ? isContentOpen : true} orientation="vertical">
        <Stack>
          {!!fieldComponent && fieldComponent}

          {!fieldComponent && (
            <TextField
              ref={textFieldRef}
              inputRef={textInputRef}
              fullWidth
              variant="outlined"
              sx={{
                background: 'white',
                borderRadius: 1,
              }}
              slotProps={
                isMultiline
                  ? {
                      htmlInput: {
                        sx: {
                          resize: 'vertical', // Разрешаем изменение размера только по вертикали
                          overflow: 'auto', // Показываем полосу прокрутки и маркер
                          scrollbarWidth: 'thin',
                          padding: '10px',
                        },
                      },
                      input: {
                        sx: {
                          padding: '0px',
                        },
                      },
                    }
                  : undefined
              }
              {...textFieldProps}
            />
          )}
        </Stack>
      </Collapse>
    </Stack>
  );
}
